var React = require('react');

function ArrowleftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.292893 7.29289C-0.0976314 7.68342 -0.0976315 8.31658 0.292892 8.7071L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34314C8.46159 1.95262 8.46159 1.31946 8.07107 0.928931C7.68054 0.538407 7.04738 0.538407 6.65686 0.928931L0.292893 7.29289ZM17 7L1 7L1 9L17 9L17 7Z","fill":"#12155F"}));
}

ArrowleftInline.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = ArrowleftInline;

ArrowleftInline.default = ArrowleftInline;
